export interface StackToggleLabels {
  on: string
  off: string
}

export const DEFAULT_STACK_TOGGLE_LABELS: StackToggleLabels = {
  on: 'Unstack series',
  off: 'Stack series',
}
